import { useEffect, useState } from 'react';

/**
 * Track browser connectivity via `navigator.onLine` and the `online`/`offline` events (§24.5).
 * The console uses this to disable and visibly mark state-changing actions while offline rather
 * than silently queuing them.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}
